module.exports = __webpack_public_path__ + "static/media/2_produkte.c433d5cb.jpg";